import React, {Component} from 'react';

export default class ValueOfTechnology extends Component {
    render(){
        const macBookImg = require('images/brand_ambassadors/rose_gold_macbook.png');
        const iPadVid = require('images/brand_ambassadors/value_of_technology_demo.mp4');
        const mobileMacBookImg = require('images/brand_ambassadors/mobile_value_of_technology.png');

        return(
            <div className='gr-12 value-of-technology'>
                    <div className='gr-4 push-1 value-of-technology-text'>
                        <h1>The value of technology</h1>
                        <p>Access over 14 million brand ambassadors to identify and engage the masses of social media to create personalized, authentic and highly engaging content to maximize brand reach and conversion.</p>
                    </div>
                    <div className='show hide@xs gr-7 push-1 value-of-technology-media'>
                        <img src={macBookImg} />
                        <div className='value-of-technology-video'>
                            <video src={iPadVid} autoPlay={true} loop={true} />
                        </div>
                    </div>

                    <div className='hide show@xs value-of-technology-img-mobile'>
                        <img src={mobileMacBookImg} />
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/value_of_technology.js